import { COLORS } from './colors.js';

const BG = COLORS.blue.light;

export default class Background {
    draw = ({ ctx, bounds }) => {
        ctx.fillStyle = BG;
        ctx.fillRect(...bounds.params);
    };
}
